import React from 'react'
import "./previousMeetingcard.css";

const PreviousMeetingCard = ({ meeting }) => {
    

    const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

    return (
        <div className={
            meeting?.deptartmentTagMaster?.deptTag === "Facility" ?
                "prev-meeting-bg-facillity previous-meeting-card" :
                meeting?.deptartmentTagMaster?.deptTag === "IT" ?
                    "prev-meeting-bg-it previous-meeting-card" :
                    meeting?.deptartmentTagMaster?.deptTag === "HR" ?
                        "prev-meeting-bg-hr previous-meeting-card" :
                        "prev-meeting-bg-governance previous-meeting-card"
        }
        >
            {/* <div
                id={
                    meeting.deptartmentTagMaster?.deptTag === "Facility" ?
                        "facillity" :
                        meeting.deptartmentTagMaster?.deptTag === "IT" ?
                            "it" :
                            meeting.deptartmentTagMaster?.deptTag === "HR" ?
                                "hr" :
                                "governance"
                }
                className="meeting-date-icon"
            >
                <span>{new Date(meeting?.parseStartDate).getDate()}</span>{monthNames[new Date(meeting?.parseStartDate).getMonth()]}<span></span>
            </div> */}
            <div className="PrevMeetTime">
                <span className='timeSpan'>
                    {meeting?.startTime} <br />
                    &nbsp; &nbsp; &nbsp;  to <br />
                    {meeting?.endTime === "11:59 PM" ? "12:00 AM" : meeting?.endTime}
                </span>
            </div>

            <div className="upcomming-meeting-tag" style={{ paddingRight: 5 }}>
                <span
                    // id={
                    //     meeting.departmentTagMaster?.deptTag === "Facility"
                    //         ? "facilityColor"
                    //         : meeting.departmentTagMaster?.deptTag === "IT"
                    //             ? "itColor"
                    //             : meeting.departmentTagMaster?.deptTag === "HR"
                    //                 ? "hrColor"
                    //                 : "governanceColor"
                    // }

                    id={
                        meeting?.deptartmentTagMaster?.deptTag === "Facility" ?
                            "facillity" :
                            meeting?.deptartmentTagMaster?.deptTag === "IT" ?
                                "it" :
                                meeting?.deptartmentTagMaster?.deptTag === "HR" ?
                                    "hr" :
                                    "governance"
                    }

                    className="circleSpan"
                ></span>
            </div>
            <div className="upcomming-meeting-info">
                <span style={{ color: "#101010", height: '20px', textOverflow: 'ellipsis', width: '230px', overflow: 'hidden', textWrap: 'nowrap', fontSize: "13px", fontWeight: "600", paddingRight: '7px' }}>{meeting?.meetingSubject}</span>
                {/* <span style={{ color: "#101010", fontSize: "11px" }}>{meeting?.startTime} - {meeting?.endTime === "11:59 PM" ? "12:00 AM" : meeting?.endTime}</span> */}
            </div>

        </div>
    )
}

export default PreviousMeetingCard